<script>
    import { get_price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/get_price_request.js?1733898724612';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724612';
    import { to_currency } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/currency.js?1733898724612';

    export let product;
    export let locale = 'en';
    export let currency = 'EUR';
    export let force_price_display = false;

    $: final_price = get_attribute_value(product, 'final_price');
    $: regular_price = get_attribute_value(product, 'price');
    $: has_special_price = final_price < regular_price;
    $: final_price_text = final_price != null ? to_currency(final_price, locale, currency) : '';
    $: regular_price_text = regular_price != null ? to_currency(regular_price, locale, currency) : '';
    $: price_diff_text =
        final_price != null && regular_price != null
            ? to_currency(has_special_price ? regular_price - final_price : 0)
            : '';
    $: price_request = get_price_request(product);

    // Make calculated_price_percentage reactive
    $: calculated_price_percentage =
        final_price && regular_price
            ? (1 - final_price / regular_price) * 100
            : 0;
</script>

{#if price_request && !force_price_display}
    {#if $$slots.price_request}
        <div class="m-product-price__price-box no-price"><slot name="price_request" /></div>
    {/if}
{:else if has_special_price}
    <div class="m-product-price__price-box">
        <div class="new-price">
            <span class="price price--new">
                {final_price_text}
            </span>
            <span class="price--percentage">-{calculated_price_percentage.toFixed(0)}%</span>
        </div>
        <div class="old-price">
            <span class="price price--old">{window.__('product.regular_price')} {regular_price_text}</span>
            <span class="price--save">Sie sparen {price_diff_text}</span>
        </div>
    </div>
{:else}
    <div class="m-product-price__price-box">
        <span class="price">{final_price_text}</span>
    </div>
{/if}

<style>
    .price.price--new {
        word-break: unset;
    }

    .price--percentage {
        display: none;
    }
</style>